export default __webpack_public_path__ + "static/media/Lip_4_M.bfb5d6be.svg";